module.exports = __webpack_public_path__ + "static/media/digital-signage-img4.0b16662f.jpg";